var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-marker",class:{
            'marker-green' : _vm.color === 'green',
            'marker-orange' : _vm.color === 'orange',
            'marker-red' : _vm.color === 'red'
        }},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-marker-outer"},[_c('div',{staticClass:"color-marker-inner"})])}]

export { render, staticRenderFns }